module.exports = __webpack_public_path__ + "img/Life-Science-Accelerator.591bd63a.png";